import Vue from 'vue';

import { formatCurrency } from '@/core/currency/helpers';

export function useFormatCurrencyFilter() {
    Vue.filter('currency', formatCurrency);
}
